export enum AREA_ACTIONS {
  SELECT = 'SELECT',
  DESELECT = 'DESELECT',
  SELECT_ALL = 'SELECT_ALL',
  DESELECT_ALL = 'DESELECT_ALL'
}
